import { render } from "./DotView.vue?vue&type=template&id=50ec6bc6"
import script from "./DotView.vue?vue&type=script&lang=js"
export * from "./DotView.vue?vue&type=script&lang=js"
script.render = render

export default script